<nav class="bg-surface-0 grid grid-cols-3 items-center p-2 shadow-md select-none">
  <h1 class="font-family-din text-surface-700 text-md font-bold">{{ name() }}</h1>
  @if (steps() > 0) {
    <rid-progress-bar class="h-4" [steps]="steps()" [progress]="progress()" />
  }
</nav>
